import { Capacitor } from "@capacitor/core";
import { Device } from "@capacitor/device";
import { EdgeToEdge } from "@capawesome/capacitor-android-edge-to-edge-support";

export const enableEdgeToEdge = async () => {
  if (Capacitor.getPlatform() !== "android") {
    return;
  }

  const { osVersion } = await Device.getInfo();
  const majorAndroidVersion = parseInt(osVersion.split(".")[0], 10);

  await EdgeToEdge.setBackgroundColor({
    color: "#4F76BA"
  })
  if (majorAndroidVersion >= 11) {
    await EdgeToEdge.enable();
  } else {
    await EdgeToEdge.disable();
  }
};
